<div class="container mt-4">
  <div class="d-flex justify-content-between align-items-center mb-4">
    <h2>View Quotation Details</h2>
  </div>
  <form [formGroup]="quotationForm" (ngSubmit)="updateDetails()">
    <!-- Section 1 -->
    <div class="row mb-3 border p-4 rounded">
      <div class="col-md-4">
        <div class="d-flex align-items-center">
          <strong class="me-2">Quote ID:</strong>
          <span>{{ quotationData?.quotationFields?.quotationId || "-" }}</span>
        </div>
      </div>
      <div class="col-md-4">
        <div class="d-flex align-items-center">
          <strong class="me-2">Company Name:</strong>
          <span>{{ quotationCommonServices?.getClientName(quotationData?.quotationFields?.quotationCompanyId ||
            -1)?.companyName || '-' }}</span>
        </div>
      </div>
      <div class="col-md-4">
        <div class="d-flex align-items-center">
          <strong class="me-2">Value:</strong>
          <span>{{ quotationData?.quotationFields?.grandTotal || '-' }}</span>
        </div>
      </div>
    </div>

    <!-- Section 2 -->
    <div class="row mb-3 border p-4 rounded">
      <div class="col-md-4">
        <label for="importance" class="form-label">Importance:</label>
        <select id="importance" class="form-select" formControlName="importance">
          <option value="very-high">Very High</option>
          <option value="high">High</option>
          <option value="medium">Medium</option>
          <option value="low">Low</option>
        </select>
      </div>
      <div class="col-md-4">
        <label for="status" class="form-label">Status:</label>
        <select id="status" class="form-select" formControlName="status">
          <option value="open">Open</option>
          <option value="won">Won</option>
          <option value="closed">Closed</option>
        </select>
      </div>
      <div class="col-md-4">
        <label for="reason" class="form-label">Reason</label>
        <select id="reason" class="form-select" formControlName="reason">
          <option value=null disabled>Select a reason</option>
          <option *ngFor="let reason of quotationCommonServices?.quotationCloseReasonsList" [value]="reason.id">
            {{ reason.quotationCloseReason }}
          </option>
        </select>
      </div>
      <div class="row mt-3">
        <div class="col-md-12">
          <button type="submit" class="btn btn-primary" [disabled]="!hasPermission()">Update</button>
        </div>
      </div>

    </div>
  </form>

  <!-- Tab Bar -->
  <ul class="nav nav-tabs">
    <li class="nav-item">
      <a class="nav-link" [class.active]="activeTab === 'details'" (click)="changeActiveTab('details')">Quotation
        Details</a>
    </li>
    <li class="nav-item">
      <a class="nav-link" [class.active]="activeTab === 'followup'" (click)="changeActiveTab('followup')">Follow Up</a>
    </li>
    <li class="nav-item">
      <a class="nav-link" [class.active]="activeTab === 'contactClient'"
        (click)="changeActiveTab('contactClient')">Contact Client</a>
    </li>
    <li class="nav-item">
      <a class="nav-link" [class.active]="activeTab === 'otherActiveQuotations'"
        (click)="changeActiveTab('otherActiveQuotations')">Other Active Quotations</a>
    </li>
  </ul>

  <!-- Tab Content -->
  <div class="tab-content mt-3">
    <div *ngIf="activeTab === 'details'" class="tab-pane active">
      <app-quotation-details [quotationFields]="quotationData?.quotationFields || {}"
        [quotationItems]="quotationData?.quotationItems || []" [quotationTerms]="quotationTermsNames">
      </app-quotation-details>
    </div>
    <div *ngIf="activeTab === 'contactClient'" class="tab-pane active">
      <app-contact-client
        [companyDetails]="quotationCommonServices?.getClientName(quotationData?.quotationFields?.quotationCompanyId || -1)"
        [memberDetails]="quotationCommonServices?.getMemberName(quotationData?.quotationFields?.quotationAttentionId || -1)"></app-contact-client>
    </div>
    <div *ngIf="activeTab === 'followup'" class="tab-pane active">
      <app-followup [quotationId]="quotationData?.quotationFields?.id"></app-followup>
    </div>
    <div *ngIf="activeTab === 'otherActiveQuotations'" class="tab-pane active">
      <app-otherquotations [otherActiveQuotations]="otherQuotations"
        [currentQuotationId]="quotationData?.quotationFields?.id"></app-otherquotations>
    </div>

  </div>
</div>
